import { useState } from 'react';
import Fab from '@mui/material/Fab';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import { ContactSupportDialog } from 'components/ContactSupportDialog';

export function ContactSupport() {
  const [isDialogOpen, setDialogOpen] = useState(false);

  return (
    <>
      <div className="hidden m:block">
        <Fab
          aria-label="Hilfe"
          size="small"
          variant="extended"
          sx={{
            backgroundColor: '#F0E648',
            ':hover': { backgroundColor: '#E7DA13' },
            '&.Mui-focusVisible': {
              outline: '2px solid #ffffff',
              outlineOffset: '2px'
            }
          }}
          onClick={() => setDialogOpen(true)}
        >
          <SupportAgentIcon sx={{ width: 32, height: 32 }} />
          Hilfe
        </Fab>
      </div>
      <div className="fixed left-[40px] bottom-[100px] z-[100] m:invisible s:visible">
        <Fab
          aria-label="info"
          sx={{
            width: 44,
            height: 44,
            backgroundColor: '#F0E648',
            ':hover': { backgroundColor: '#E7DA13' }
          }}
          onClick={() => setDialogOpen(true)}
        >
          <SupportAgentIcon sx={{ width: 24, height: 24 }} />
        </Fab>
      </div>
      {isDialogOpen && (
        <ContactSupportDialog
          isDialogOpen={isDialogOpen}
          onDialogClose={() => setDialogOpen(false)}
        />
      )}
    </>
  );
}
